/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'
import {Button, Card, Col, Form, Row} from 'react-bootstrap'
import Editor from '../../../_metronic/layout/components/editor/Editor'
import {GetAnnouncementService} from '../../service/announcement.service'
import {useUserSelector} from '../../store/user'
import {GetTCService} from '../../service/tc.service'

const AnnouncementPage = ({companySelected}) => {
  const [state, setState] = useState({value: ''})
  const [doing, setDoing] = useState(false)
  useEffect(() => {
    if (companySelected) {
      handleGetAnnouncement()
    }
  }, [companySelected])

  const handleGetAnnouncement = () => {
    setDoing(true)
    const getAnnouncement = new GetAnnouncementService()
    getAnnouncement
      .request(companySelected)
      .then((res) => {
        if (res.data) {
          setState({value: res.data.content})
        } else {
          setState({value: ''})
        }
      })
      .catch((err) => {
        console.log('err', err)
      })
      .finally(() => {
        setDoing(false)
      })
  }

  return (
    <>
      <h1 className='mb-5'>{`Announcement`}</h1>
      {doing ? (
        <>
          <p className='placeholder-glow mt-2'>
            <span className='placeholder bg-secondary col-12' style={{height: 200}}></span>
          </p>
        </>
      ) : (
        <>
          <div className='w-100'>
            <div dangerouslySetInnerHTML={{__html: state.value}} />
          </div>
        </>
      )}
    </>
  )
}

const TermConditionPage = ({companySelected}) => {
  const [state, setState] = useState({value: ''})
  const [doing, setDoing] = useState(false)

  useEffect(() => {
    if (companySelected) {
      handleGetTC()
    }
  }, [companySelected])

  const handleGetTC = () => {
    setDoing(true)
    const getTC = new GetTCService()
    getTC
      .request(companySelected)
      .then((res) => {
        if (res.data) {
          setState({value: res.data.content})
        } else {
          setState({value: ''})
        }
      })
      .catch((err) => {
        console.log('err', err)
      })
      .finally(() => {
        setDoing(false)
      })
  }

  return (
    <>
      <h1 className='my-5'>{`Terms & Conditions`}</h1>
      {doing ? (
        <>
          <p className='placeholder-glow mt-2'>
            <span className='placeholder bg-secondary col-12' style={{height: 200}}></span>
          </p>
        </>
      ) : (
        <>
          <div className='w-100'>
            <div dangerouslySetInnerHTML={{__html: state.value}} />
          </div>
        </>
      )}
    </>
  )
}

const HomePage: FC = () => {
  const [companySelected, setCompanySelected] = useState('')
  const {user, myCompany} = useUserSelector()

  useEffect(() => {
    if (user) {
      if (user.companies.length > 0) {
        if (myCompany) {
          setCompanySelected(myCompany.company.id)
        } else {
          setCompanySelected(user.companies[0].company.id)
        }
      }
    }
  }, [user])

  return (
    <>
      <Card>
        <Card.Body>
          {/* {!myCompany && (
            <Row>
              <Col xs={12} sm={6}>
                <Form.Group className='mb-3'>
                  <Form.Label>Company</Form.Label>
                  <Form.Select
                    name={'companyId'}
                    onChange={(e) => setCompanySelected(e.target.value)}
                    value={companySelected}
                  >
                    {user?.companies.map((item) => {
                      return (
                        <option value={item['company']['id']} key={item['company']['id']}>
                          {item['company']['name']}
                        </option>
                      )
                    })}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
          )} */}
          <AnnouncementPage companySelected={companySelected} />
          <TermConditionPage companySelected={companySelected} />
        </Card.Body>
      </Card>
    </>
  )
}

export {HomePage}
